import { Inventory } from "../../types/inventory";
import { Alert, Typography } from "@mui/material";
import { ProductCard } from "./ProductCard";
import React from "react";

function ResaleStateMessage({ state }: { state: string }) {
  switch (state) {
    case "resellable":
      return (
        <>
          This inventory is <code>resellable</code> and is included in the product's stock quantity.
        </>
      );
    case "reserved":
      return (
        <>
          This inventory is <code>reserved</code> for a customer.
        </>
      );
    case "invoiced":
      return (
        <>
          This inventory is <code>invoiced</code> and has been sold.
        </>
      );
    default:
      return (
        <>
          When in the state of <code>resellable</code>, this inventory will be included in the product's stock quantity.
        </>
      );
  }
}

export function ResaleSection({ inventory }: { inventory: Inventory }) {
  const product = inventory.product;
  return (
    <>
      <Typography variant="h6" sx={{ color: "#0089BD" }}>
        Resale
      </Typography>
      {inventory.listable ? (
        <>
          {product ? (
            <Typography color="text.secondary">
              This inventory is associated with this product:
              <ProductCard product={product} />
              <ResaleStateMessage state={inventory.state} />
            </Typography>
          ) : (
            <Alert severity="error">
              This inventory is listable but is not associated with a product in the catalog. Contact Engineering.
            </Alert>
          )}
        </>
      ) : (
        <Typography color="text.secondary">
          This inventory is not listable in the product catalog because:
          <ul>
            {inventory.listabilityErrors?.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </Typography>
      )}
    </>
  );
}
